import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Modal, Form } from "react-bootstrap";
import Breadcrums from "../../common/breadcrumbs";
import CustomPagination from "../../common/custompagination";
import Loader from "../../common/loader";
import * as bookingService from "../../services/booking.services";
import { formateDateWithMonth } from "../../../../utils/commonfunction";

const ConsultationRescheduleList = () => {
  const [list, setList] = useState([]);
  const [datalength, setDataLength] = useState(0);
  const [itemperpage] = useState(10);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [actionLoader, setActionLoader] = useState(false);
  const [globalsearch, setGlobalSearch] = useState("");
  const [sorting] = useState({ order: -1, column: "created_at" });
  const [search, setSearch] = useState({ status: "rescheduled" });

  const [showModal, setShowModal] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [rescheduleDate, setRescheduleDate] = useState("");
  const [rescheduleStartTime, setRescheduleStartTime] = useState("");
  const [rescheduleEndTime, setRescheduleEndTime] = useState("");

  const breadcrumbs = [
    { title: "Dashboard", url: "/admin/dashboard" },
    { title: "Consultation Reschedule", url: "" },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(true);
      const formData = new FormData();
      formData.append("page", page);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(search));
      formData.append("global_search", globalsearch);

      bookingService
        .List(formData)
        .then((res) => {
          setList(res?.data?.list || []);
          setDataLength(res?.data?.total_records || 0);
          setPage(res?.data?.page || 1);
          setLoader(false);
        })
        .catch(() => {
          setLoader(false);
        });
    }, 300);

    return () => clearTimeout(timer);
  }, [page, itemperpage, sorting, search, globalsearch]);

  const resetFilter = () => {
    setGlobalSearch("");
    setSearch({ status: "rescheduled" });
    setPage(1);
  };

  const openRescheduleModal = (booking) => {
    setSelectedBookingId(booking?.id || null);
    setRescheduleDate(booking?.booking_date || "");
    setRescheduleStartTime(booking?.booking_start_time || "");
    setRescheduleEndTime(booking?.booking_end_time || "");
    setShowModal(true);
  };

  const handleReschedule = () => {
    if (!selectedBookingId) {
      Swal.fire("Error", "Invalid booking selected", "error");
      return;
    }
    if (!rescheduleDate || !rescheduleStartTime || !rescheduleEndTime) {
      Swal.fire("Warning", "Please select date, start time and end time", "warning");
      return;
    }

    setActionLoader(true);
    bookingService
      .RescheduleBooking({
        booking_id: selectedBookingId,
        date: rescheduleDate,
        start_time: rescheduleStartTime,
        end_time: rescheduleEndTime,
      })
      .then((res) => {
        setActionLoader(false);
        if (res?.success || res?.data?.success) {
          Swal.fire("Success", "Consultation rescheduled successfully", "success");
          setShowModal(false);
          setPage(1);
          setSearch({ status: "rescheduled" });
        } else {
          Swal.fire("Error", res?.message || res?.data?.message || "Failed to reschedule", "error");
        }
      })
      .catch((err) => {
        setActionLoader(false);
        Swal.fire("Error", err?.response?.data?.message || "Failed to reschedule", "error");
      });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label mb-0">Reschedule Consultations</h6>
              <div className="d-flex align-items-center gap-2">
                <div className="form-group mb-0">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search consultations..."
                    value={globalsearch}
                    onChange={(e) => setGlobalSearch(e.target.value)}
                  />
                </div>
                <button className="btn btn-outline-warning" onClick={resetFilter}>
                  Reset
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered text-nowrap w-100">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>User</th>
                    <th>Astrologer</th>
                    <th>Consultation Type</th>
                    <th>Old Date & Time</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Payment</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan="9" className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  ) : list.length > 0 ? (
                    list.map((row, i) => (
                      <tr key={row.id || row._id || i}>
                        <td>{(page - 1) * itemperpage + i + 1}</td>
                        <td>{row?.User?.name || row?.user?.name || "N/A"}</td>
                        <td>{row?.Astrologer?.name || row?.astrologer?.name || "N/A"}</td>
                        <td>{row?.consultation_type || row?.ConsultationPrice?.type || "N/A"}</td>
                        <td>
                          {row?.booking_date ? (
                            <>
                              {formateDateWithMonth(row?.booking_date)}
                              <br />
                              {row?.booking_start_time || "-"} - {row?.booking_end_time || "-"}
                            </>
                          ) : (
                            <span className="text-muted">Not Scheduled Yet</span>
                          )}
                        </td>
                        <td>{row?.amount !== undefined && row?.amount !== null ? `${row?.currency === "USD" ? "$" : "₹"}${Number(row.amount).toFixed(2)}` : "N/A"}</td>
                        <td>
                          <span className="badge badge-warning">
                            {row?.status || "N/A"}
                          </span>
                        </td>
                        <td>
                          {row?.payment_method || "N/A"} ({row?.payment_status || "N/A"})
                        </td>
                        <td className="text-center">
                          <button
                            className="btn ripple btn-main-primary signbtn"
                            onClick={() => openRescheduleModal(row)}
                          >
                            Reschedule
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="mt-3 d-flex justify-content-between align-items-center">
              <b>Total Records: {datalength}</b>
              {datalength > 0 && (
                <CustomPagination
                  datalength={datalength}
                  itemperpage={itemperpage}
                  currentPage={page}
                  setPage={setPage}
                  pageRoute={[
                    {
                      name: "Consultation Reschedule",
                      path: "/admin/consultation/reschedules",
                    },
                  ]}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        className="custom-modal"
        style={{ visibility: "visible", pointerEvents: "initial" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Reschedule Consultation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">New Date</Form.Label>
            <Form.Control
              type="date"
              value={rescheduleDate}
              onChange={(e) => setRescheduleDate(e.target.value)}
              min={new Date().toISOString().split("T")[0]}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Start Time</Form.Label>
            <Form.Control
              type="time"
              value={rescheduleStartTime}
              onChange={(e) => setRescheduleStartTime(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">End Time</Form.Label>
            <Form.Control
              type="time"
              value={rescheduleEndTime}
              onChange={(e) => setRescheduleEndTime(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger ripple" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button
            className="btn ripple btn-main-primary signbtn"
            onClick={handleReschedule}
            disabled={actionLoader}
          >
            {actionLoader ? "Saving..." : "Save Reschedule"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConsultationRescheduleList;
